module.exports = __webpack_public_path__ + "img/com31.7c562017.png";